import React, {useState, useEffect } from 'react';
import Blog from './BlogSection';
import About from './AboutSection';
import Service from './ServiceSection';
import HomeSlider from './SliderSection';
import Campus from './CampusSection';
import Course from './CourseSection';
import Event from './EventSection';
import Counter from './CounterSection';
import Testimonial from './TestimonialSection';
import ScrollToTop from '../../components/ScrollTop';
import AboutPart from '../about/AboutSection';
import HomeAboutPart from '../about/HomeAbout';
import Midbanner from './midBanner';
import IndustryPartner from './industrypartner';
import GovPartner from './govPartners';
import OurMoments from '../about/OurMoments';
import HomeService from '../../services/home.service';
import TransformingFuture from './TransformingFuture';
import AwardsAndRecogination from './AwardsAndRecogination';

const HomeMain =() => {
	const [data,setData]=useState({});

	useEffect(()=>{
		HomeService.list()
		.then(res=>
			// console.log(res)
			setData(res.data[0])
		)
		.catch(err=>console.log(err));

	},[]);


	console.log("Fardeen------>",data);

		return (
			<>
				<div className="react-wrapper">
            		<div className="react-wrapper-inner">
						<HomeSlider />
						<HomeAboutPart />
						<Service />
						<TransformingFuture data={data?.transformingFuture}/>
						<AwardsAndRecogination/>
						<AwardsAndRecogination type="media"/>
						<IndustryPartner govtPartnerList={data?.govPartnersDetail}/>
						<GovPartner industryPartnerList={data?.industryPartnersDetail}/>
						<Event storyList={data?.storyDetail}/>

						{/* <Midbanner/> */}
						{/* Service-area-end */}

						{/* About-area-start */}
						{/* <About /> */}
						{/* About-area-end */}

						{/* Campus-area-start */}
						{/* <Campus /> */}
						{/* Campus-area-end */}

						{/* Course-area-start */}
						{/* <Course courseList={data?.courseDetail}/> */}
						{/* Course-area-end */}

						{/* Counter-area-start */}
						
						{/* Counter-area-end */}

						{/* Event-area-start */}
						{/* <Counter /> */}

								{/* testmonial-area-start */}
								{/* <Testimonial /> */}
						{/* testmonial-area-end */}
						{/* <OurMoments/> */}
						{/* Event-area-end */}

				

						{/* blog-area-start */}
						<Blog blogList={data?.blogsDetail}/>
						{/* blog-area-end */}

						{/* scrolltop-start */}
						<ScrollToTop
							scrollClassName="home react__up___scroll"
						/>
						{/* scrolltop-end */}
					</div>
				</div>

			</>
		);
	}

export default HomeMain;